// Keeps the thread at its bottom while the user is there. A user who scrolls up keeps their place. Each conversation has
// its own thread element, so opening another conversation mounts the hook again, at the bottom.
const NEAR_BOTTOM_PX = 80;

function nearBottom({ scrollHeight, scrollTop, clientHeight }) {
  return scrollHeight - scrollTop - clientHeight < NEAR_BOTTOM_PX;
}

const hook = {
  mounted() {
    this.scroller = this.el.parentElement;
    this.toBottom();
  },

  beforeUpdate() {
    this.follow = nearBottom(this.scroller);
  },

  updated() {
    if (this.follow) this.toBottom();
  },

  toBottom() {
    this.scroller.scrollTop = this.scroller.scrollHeight;
  },
};

export default hook;
